/**
 * The viewport meta per screen. The page may be pinch-zoomed everywhere (WCAG 1.4.4) except on the canvas screens, where
 * the browser's own zoom would fight the board's: the board (`/b/:boardId`) and the guest link (`/s`).
 *
 * `public/theme-init.js` sets the same content before the first paint, but it runs once per document load: the
 * History-API router calls `syncViewport` on every client-side navigation. `viewport.test.ts` keeps both in step.
 */
export const VIEWPORT_BASE = 'width=device-width, initial-scale=1, viewport-fit=cover';
export const VIEWPORT_LOCKED = `${VIEWPORT_BASE}, maximum-scale=1`;

/** The same pattern as ROUTES.board and ROUTES.share (router.tsx: `[\w-]{1,64}` params, optional trailing slash). */
const CANVAS_PATH = /^\/(b\/[\w-]{1,64}|s)\/?$/;

export const viewportContentFor = (pathname: string): string => (CANVAS_PATH.test(pathname) ? VIEWPORT_LOCKED : VIEWPORT_BASE);

/** Points <meta name=viewport> at the screen `pathname` shows; a no-op when it already does (no DOM write, no re-render). */
export function syncViewport(pathname: string): void {
  const meta = document.querySelector('meta[name="viewport"]');
  const content = viewportContentFor(pathname);
  if (meta && meta.getAttribute('content') !== content) meta.setAttribute('content', content);
}
